import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

export interface DlgConfirmComponentData {
  title?: string,
  message?: string,
  closeLabel?: string,
  confirmLabel?: string
}

@Component({
    selector: 'app-dlg-confirm',
    imports: [
        MatDialogModule,
        MatButtonModule,
        ReactiveFormsModule, FormsModule,
        MatInputModule
    ],
    templateUrl: './dlg-confirm.component.html',
    styleUrl: './dlg-confirm.component.scss'
})
export class DlgConfirmComponent {
  title: string | undefined
  message: string | undefined
  closeLabel: string | undefined
  confirmLabel: string | undefined
  constructor(
    public dialogRef: MatDialogRef<DlgConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DlgConfirmComponentData
  ) {
    this.title = data.title ? data.title : "Confirmar"
    this.message = data.message ? data.message : "Para confirmar la siguiente acci\xf3n, click en aceptar!"
    this.confirmLabel = data.confirmLabel ? data.confirmLabel : "Continuar"
    this.closeLabel = data.closeLabel ? data.closeLabel : "Cancelar"
  }

  close() {
    this.dialogRef.close(true);
  }
}
